import React from "react";
import { ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const dishes = [{
  id: 1,
  name: "Vesterhavsost & Rye",
  description: "Aged North Sea cheese paired with crisp dark rye, fermented forest berries, and wild coastal herbs.",
  price: "145 DKK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/imperial_peking_duck_roast.png",
  className: "md:col-span-2 md:row-span-2 min-h-[400px]"
}, {
  id: 2,
  name: "Cold-Smoked Salmon",
  description: "Juniper-cured salmon with cucumber ribbons, dill emulsion, and fresh horseradish snow.",
  price: "185 DKK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/wagyu_beef_tataki_seared.png",
  className: "md:col-span-1 md:row-span-1 min-h-[300px]"
}, {
  id: 3,
  name: "Wild Forest Venison",
  description: "Roasted loin with salt-baked celeriac, pickled chanterelles, and a concentrated game jus.",
  price: "295 DKK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/royal_pad_thai_prawns.png",
  className: "md:col-span-1 md:row-span-1 min-h-[300px]"
}, {
  id: 4,
  name: "Salt-Baked Beets",
  description: "Heirloom beets with smoked yogurt, toasted hazelnuts, and brown butter vinaigrette.",
  price: "165 DKK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/stone_bowl_bibimbap_sizzle.png",
  className: "md:col-span-1 md:row-span-1 min-h-[300px]"
}, {
  id: 5,
  name: "Sea Buckthorn Tart",
  description: "Sharp coastal berries on a shortcrust base with burnt meringue and aromatic pine needle oil.",
  price: "125 DKK",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1602682/img/matcha_silk_tiramisu_dessert.png",
  className: "md:col-span-2 md:row-span-1 min-h-[300px]"
}];
export default function SignatureCreations() {
  return <section data-section-id="39364" id="seasonal-interpretations" className="dark bg-card text-foreground py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-light tracking-tight mb-4 text-foreground italic">
              Seasonal Interpretations
            </h2>
            <p className="text-muted-foreground text-lg font-sans font-light leading-relaxed tracking-normal">
              An innovative journey through the latest Nordic cuisine, featuring seasonal dishes crafted from locally sourced ingredients that celebrate the evolving gastronomy of Denmark.
            </p>
          </div>
          <div className="shrink-0">
            <Button asChild variant="outline" className="rounded-none border-primary/40 hover:bg-primary hover:text-background hover:border-primary transition-all duration-500 uppercase font-mono text-xs tracking-widest">
              <Link to="/TheMenuPage">
                Explore The Menu <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {dishes.map((dish, i) => <Card key={dish.id} data-index={i} className={`group relative border-0 rounded-none overflow-hidden shadow-none bg-transparent ${dish.className}`}>
              {}
              <div className="absolute inset-0 w-full h-full">
                <img src={dish.image} alt={dish.name} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-700" />
              </div>

              <CardContent className="relative h-full flex flex-col justify-between p-0">
                {}
                <div className="self-start mt-6 ml-6 md:mt-8 md:ml-8 opacity-0 group-hover:opacity-100 transition-opacity duration-700 delay-100">
                  <div className="bg-background/80 text-foreground px-4 py-2 backdrop-blur-md border-l border-primary">
                    <h3 className="font-serif text-base md:text-lg font-light tracking-wider leading-tight uppercase">
                      {dish.name}
                    </h3>
                  </div>
                </div>

                {}
                <div className="p-6 md:p-8 mt-auto">
                  <div className="flex flex-col gap-3 transform translate-y-4 transition-all duration-700 group-hover:translate-y-0">
                    <p className="text-muted-foreground text-sm md:text-base font-sans font-light leading-relaxed max-w-prose">
                      {dish.description}
                    </p>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="h-px w-6 bg-primary/40" />
                      <span className="font-mono text-xs md:text-sm text-primary tracking-widest uppercase">
                        {dish.price}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}